/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
function createFocusWalker(root) {
  return document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode(node) {
      return (// `.tabIndex` is not the same as the `tabindex` attribute. It works on the
        // runtime's understanding of tabbability, so this automatically accounts
        // for any kind of element that could be tabbed to.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        node.tabIndex >= 0 && !node.disabled ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
      );
    }
  });
}
/**
 * Given a `root` container element and a `target` that is outside of that
 * container and intended to receive focus, force the DOM focus to wrap around
 * such that it remains within `root`.
 *
 * If `forceFirst` is set to `true`, the wrap will always attempt to focus the
 * first viable element in `root`, rather than wrapping to the end.
 */


function wrapFocus(root, target) {
  var forceFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var forceElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var newFocus;

  if (forceElement != null) {
    newFocus = forceElement;
  } else {
    var walker = createFocusWalker(root);
    var position = target.compareDocumentPosition(root);
    var wrappedTarget = null;

    if (position & Node.DOCUMENT_POSITION_PRECEDING || forceFirst) {
      wrappedTarget = walker.firstChild();
    } else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
      wrappedTarget = walker.lastChild();
    }

    newFocus = wrappedTarget != null ? wrappedTarget : root;
  }

  newFocus.focus();
}

export { wrapFocus as default };
